var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12381_7507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2922",
    d: "M17.86 0.166491H-1.52588e-05V21H17.86V0.166491Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12381_7507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2928",
    d: "M0.523215 17.9062C0.523215 11.8386 4.73995 6.91983 9.94157 6.91983H10.9881V3.25769L17.3367 9.36125L10.9881 14.2441V10.582H9.94157C5.63923 10.582 2.44728 13.4174 0.523215 17.9062Z",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo1);
export default __webpack_public_path__ + "static/media/Redo_1.7dd0abd42a84c438afe8e7c7e0913cb5.svg";
export { ForwardRef as ReactComponent };